<template>

  <div :class="wrapperClass" :key="uuid" class="form-group">

    <label :for="idElement()" v-if="label || semindice" :title="label">
      {{label}}

      <i v-if="help" class="fal fa-question-circle pointer ml-1 small" :title="help"></i>

      <slot name="label"></slot>

      <slot name="extra-label-slot"></slot>

    </label>

    <slot name="actions"></slot>

    <slot name="rodape"></slot>

    <div class="input-group">
      <slot name="input"></slot>

      <template v-if="inputType"> <!-- ====================================================== -->
        <input :data-testid="dataTestid" :id="idElement()" :name="idElement()" :key="idElement()" @change="changeEvent" :type="inputType" @keyup.enter="$emit('enter')" ref="input" @keypress="$emit('keyp')"
               v-bind="attrs" v-model="model" v-on="events" :min="min != '' ? min : (inputType == 'date' ? '1111-01-01' : '')" :max="max != '' ? max : (inputType == 'date' ? '9999-12-31' : (inputType == 'month' ? '9999-12' : ''))" >
      </template>

      <template v-if="type == 'number'"> <!-- ====================================================== -->
        <input :data-testid="dataTestid" :id="idElement()" :key="idElement()" @keyup.enter="$emit('enter')" ref="input"
               type="number" v-bind="attrs" v-model.number="model" v-on="events" :min="min" @wheel="$event.target.blur()">
      </template>

      <template v-else-if="mask"> <!-- ====================================================== -->
        <input :id="idElement()" :key="idElement()" @keyup.enter="$emit('enter')" ref="input" type="tel"
               v-bind="attrs" v-mask="mask" v-model="model" v-on="events">
      </template>

      <template v-else-if="type == 'currency'"> <!-- ====================================================== -->
        <!--        <money ></money>-->
        <currency-input
          :id="idElement()" :key="idElement()" :data-testid="dataTestid" ref="input" v-bind="attrs" v-model="model" v-on="events"
          :currency="null" :distraction-free="{hideNegligibleDecimalDigits : true, hideGroupingSymbol : false}"
          locale="de-DE"
        />
      </template>

      <template v-else-if="type == 'textarea'"> <!-- ====================================================== -->
        <textarea :id="idElement()" :key="idElement()" :data-testid="dataTestid" ref="input" :rows="rowsTextarea"
                  v-bind="attrs" v-model.trim="model" v-on="events" @input="ajustarAltura"></textarea>
      </template>

      <template v-else-if="type == 'select'"> <!-- ====================================================== -->
        <select :id="idElement()" :key="idElement()" @keyup.enter="$emit('enter')" ref="input" v-bind="attrs"
                v-model="model" v-on="events" :disabled="disabled" :data-testid="dataTestid" data-test="select-option">

          <option hidden>{{placeholder || '-'}}</option>

          <option :disabled="option.disabled" :hidden="option.hidden" :key="'options'+index" :value="option.id"
                  v-for="(option, index) in options">
            {{ option.name || option.nome }}
          </option>

        </select>
      </template>

      <template v-else-if="type == 'select-group'"> <!-- ====================================================== -->
        <select :id="idElement()" :key="idElement()" @keyup.enter="$emit('enter')" ref="input" v-bind="attrs"
                v-model="model" v-on="events" :disabled="disabled" :data-testid="dataTestid">

          <option hidden>{{placeholder || '-'}}</option>

          <optgroup :disabled="group.disabled" :hidden="group.hidden" :key="'group'+index" v-for="(group, index) in options" :label="group.name || group.nome">
            <option :disabled="option.disabled" :hidden="option.hidden" :key="'options'+optIdx" :value="option.id"
                    v-for="(option, optIdx) in group.options">
              {{ option.name || option.nome }}
            </option>
          </optgroup>

        </select>
      </template>

      <template v-else-if="type == 'optgroup'"> <!-- ====================================================== -->
        <select :id="idElement()" :key="idElement()" @keyup.enter="$emit('enter')" ref="input" v-bind="attrs"
                v-model="model" v-on="events" :disabled="disabled" :data-testid="dataTestid" data-test="select-option">

          <option hidden>{{placeholder || '-'}}</option>

          <optgroup :label="optgroup.name || optgroup.nome" v-for="(optgroup, i) in options" :key="'optgroup'+i" >
            <option :disabled="option.disabled" :hidden="option.hidden" :key="'optgroup'+i+'options'+index" :value="option.id"
                    v-for="(option, index) in optgroup.options">
              {{ option.name || option.nome }}
            </option>
          </optgroup>

        </select>


      </template>

      <template v-else-if="type == 'select-name'"> <!-- ====================================================== -->

        <select :id="idElement()" :key="idElement()" @keyup.enter="$emit('enter')" ref="input" v-bind="attrs"
                v-model="model" v-on="events">

          <option hidden>{{placeholder || '-'}}</option>

          <option :disabled="option.disabled" :hidden="option.hidden" :key="'options'+index" :value="option.id"
                  v-for="(option, index) in options">
            {{ option[nameOptionSelect] }}
          </option>

        </select>

      </template>

      <template v-else-if="type == 'v-select'"> <!-- ====================================================== -->
        <v-select :data-testid="dataTestid" :clearable="clearable" :filterBy="filterBy" :id="idElement()" :key="idElement()" :options="options"
                  :reduce="o => o.id" :value="model" @change="changeEvent" @input="update" @keyup.enter="$emit('enter')"
                  :selectable="(o) => !o.hidden && !o.disabled" :disabled="disabled"
                  class="vs-drop-active" label="nome" :title="titleVSelect"
                  append-to-body :calculate-position="withPopper"
                  max-height="200px" ref="input" v-bind="attrs">
          <!--          max-height="200px" ref="input" v-bind="attrs" v-on="events">-->
          <template v-slot:option="option" v-if="setOrderedList">
            <span :class="`ml-${option.ordem != 0 ? option.ordem+2: 0}`">{{option.nome }}</span>
          </template>
          <template #no-options>Nenhum item encontrado</template>
        </v-select>
      </template>

      <template v-else-if="type == 'v-multi-select'"> <!-- ====================================================== :append-to-body="true" -->
        <v-select :clearable="true" :filterBy="filterBy" :id="idElement()" :key="idElement()" :options="options"
                  :reduce="o => o.id" :value="model" @change="changeEvent" @input="update" @keyup.enter="$emit('enter')"
                  :selectable="(o) => !o.hidden && !o.disabled"
                  :data-testid="dataTestid"
                  class="vs-drop-active" label="nome" multiple
                  append-to-body :calculate-position="withPopper"
                  max-height="200px" ref="input" v-bind="attrs">
          <!--          max-height="200px" ref="input" v-bind="attrs" v-on="events">-->
          <template v-slot:option="option" v-if="setOrderedList">
            <span :class="`ml-${option.ordem != 0 ? option.ordem+2: 0}`">{{option.nome }}</span>
          </template>
          <template #no-options>Nenhum item encontrado</template>
        </v-select>
      </template>

      <template v-else-if="type == 'tags'"> <!-- ====================================================== -->
        <v-select :id="idElement()" :key="idElement()" :options="options" :data-testid="dataTestid"
                  :taggable="taggable" multiple :value="model" @change="changeEvent" @input="update" @keyup.enter="$emit('enter')"
                  class="vs-drop-active" label="nome"
                  append-to-body :calculate-position="withPopper"
                  max-height="200px" ref="input" v-bind="attrs">
          <!--          max-height="200px" ref="input" v-bind="attrs" v-on="events">-->
          <template v-slot:option="option" v-if="setOrderedList">
            <span :class="`ml-${option.ordem != 0 ? option.ordem+2: 0}`">{{option.nome }}</span>
          </template>
          <template #no-options>Nenhum item encontrado</template>
        </v-select>
      </template>

      <template v-else-if="type == 'radio'"> <!-- ====================================================== -->

        <div class="custom-controls-stacked">

          <div :key="idElement(i)" class="form-check form-check-inline" v-for="(option, i) in options">

            <input :disabled="disabled" :readonly="readonly" :id="idElement(i)" :key="idElement(i)" :name="idElement(i)" :value="option.id"
                   @change="changeEvent($event)" :data-testid="dataTestid"
                   class="form-check-input" type="radio" v-model="model"
                   v-on="events">

            <label :for="idElement(i)" class="form-check-label">{{ option.nome }}</label>

          </div>

        </div>

      </template>

      <template v-else-if="type == 'checkbox'"> <!-- ====================================================== -->

        <div class="custom-controls-stacked">

          <div :key="idElement(i)" class="form-check form-check-inline" v-for="(option, i) in options">

            <input :disabled="disabled || option.disabled" :readonly="readonly" :id="idElement(i)" :key="idElement(i)" :value="option.id" :true-value="option.id"
                   @change="changeEvent($event)" class="form-check-input" type="checkbox"
                   v-model="model">

            <label :for="idElement(i)" class="form-check-label">{{ option.nome }}</label>

          </div>
        </div>

      </template>

      <template v-else-if="type == 'autocomplete'"> <!-- ====================================================== -->

        <suggestions :disabled="disabled" :readonly="readonly" :onInputChange="searchQueryAutocomplete" :onItemSelected="update"
                     :options="{debounce : 300, inputClass: 'form-control form-control-xs'}"
                     :id="idElement()" :key="idElement()"
                     @keyup.enter="$emit('enter')"
                     ref="input" v-model.trim="model"
                     v-on="events">

        </suggestions>

      </template>

      <template v-else-if="type == 'editor' || type == 'classic-editor' || type == 'tiny'"> <!-- ====================================================== -->
        <editor :init="tinyConfigComputed" :id="idElement()" :key="idElement()"
                :disabled="disabled" :readonly="readonly"
                :data-testid="dataTestid"
                :html-editor="htmlEditor"
                v-model.trim.lazy="model"
                v-on="events" v-bind="attrs"
                ref="editortexto"
                model-events="blur change undo redo" @onkeyup="onkeyup($event)"
                api-key="go5oky3bl2quqkutip700bunx6iw17b4obiffo48n4bz04p2"
                cloud-channel="7"
        />
      </template>

      <template v-else-if="type == 'editor-ato'"> <!-- ====================================================== -->
        <editor :init="tinyConfigAtoComputed" :id="idElement()" :key="idElement()"
                :disabled="disabled" :readonly="readonly"
                :data-testid="dataTestid"
                :html-editor="htmlEditor"
                v-model.trim.lazy="model"
                v-on="events" v-bind="attrs"
                ref="editortexto"
                model-events="blur change undo redo" @onkeyup="onkeyup($event)"
                api-key="go5oky3bl2quqkutip700bunx6iw17b4obiffo48n4bz04p2"
                cloud-channel="7"
        />
      </template>

      <template v-else-if="type == 'inline-editor'"> <!-- ====================================================== -->
        <editor :init="tinyInlineConfigComputed" :id="idElement()" :key="idElement()"
                :disabled="disabled" :readonly="readonly"
                v-model.trim.lazy="model"
                v-on="events" v-bind="attrs"
                ref="editortexto"
                model-events="blur change undo redo" @onkeyup="onkeyup($event)"
                api-key="go5oky3bl2quqkutip700bunx6iw17b4obiffo48n4bz04p2"
                cloud-channel="7"
        />
      </template>

      <template v-else-if="type == 'readonly-editor'"> <!-- ====================================================== -->
        <editor :init="readonlyConfigComputed" :id="idElement()" :key="idElement()"
                :disabled="true" :readonly="true"
                v-model.trim.lazy="model"
                v-on="events" v-bind="attrs"
                ref="editortexto"
                model-events="blur change undo redo" @onkeyup="onkeyup($event)"
                api-key="go5oky3bl2quqkutip700bunx6iw17b4obiffo48n4bz04p2"
                cloud-channel="7"
        />
      </template>

      <template v-else-if="type == 'file'">
        <div :class="{'img': model}" class="upload">
          <file-upload
            :custom-action="upload"
            :drop="false"
            :drop-directory="false"
            :id="idElement()" :key="idElement()"
            :multiple="false"
            :thread="1"
            :disabled="disabled"
            :data-testid="dataTestid"
            @input-file="start"
            accept="image/png,image/jpeg"
            class="btn btn-sm btn-outline-primary mx-1 pointer"
            extensions="jpg,jpeg,png"
            ref="upload" v-if="!model" v-model="file">

            <i class="fa fa-upload pointer" v-if="(!$refs.upload || !$refs.upload.active) && !loading"></i>

            <span aria-hidden="true"
                  class="ml-1 spinner-border spinner-border-sm" role="status" v-else></span>
          </file-upload>

          <v-button v-else-if="!disabled" :button="false" :popover="true" :run="remover" class="btn btn-sm btn-outline-primary mx-1 pointer"
                    position="dropleft">
            <i class="fal fa-times" title="Excluir"></i>
          </v-button>

          <img :src="`${server}/api/imagem-texto/${model}`" v-if="model"/>
          <div class="alert alert-outline-secondary" v-else>
            Nenhuma imagem anexada.
          </div>
        </div>
      </template>

      <div class="spinner-border spinner-border-sm text-primary" role="status"
           style="position: absolute;right: 10px;top: 25%;z-index: 9999;"
           v-if="loading"></div>

      <slot :class="{'is-invalid' : error || showError}"></slot>

      <div class="invalid-feedback" v-if="error || showError">{{error || showError}}</div>

    </div>

  </div>

</template>

<script>

import AnexoBusiness from "@/business/AnexoBusiness";
import FrontBusiness from "@/business/FrontBusiness";
import ImagemTextoBusiness from "@/business/ImagemTextoBusiness";
import utils from "@/commons/Utils";
import LimpezaEditorUtils from "@/commons/LimpezaEditorUtils";

import Editor from '@tinymce/tinymce-vue'
import Suggestions from 'v-suggestions'
import VueSelect from 'vue-select'
import {mask} from 'vue-the-mask'
import FileUpload from "vue-upload-component";
import EnumAnexoEntidade from "@/business/cloudStorage/EnumAnexoEntidade";

import { createPopper } from '@popperjs/core';
export default {
    name: "V-Input",
    directives: {mask},
    components: {
      'v-select': VueSelect,
      Suggestions,
      FileUpload,
      'editor': Editor
    },
    props: {
      value: {},
      default: {},
      id: String,
      entidade: String,
      checklist: {type: Boolean, default: false},
      clearable: {type: Boolean, default: false},
      label: String,
      type: String,
      placeholder: String,
      taggable: {type: Boolean, default: true},
      inputProps: Object,
      options: {type: Array, default: () => [{id: true, nome: 'Sim'}, {id: false, nome: 'Não'}]},
      loading: {type: Boolean, default: false},
      error: String,
      readonly: {type: Boolean, default: false},
      disabled: {type: Boolean, default: false},
      valid: {type: Boolean, default: false},
      focus: {type: Boolean, default: false},
      searchQuery: Function,
      nameOptionSelect: String,
      idindice: {type: String, default: ''},
      semindice: {type: Boolean, default: false},
      setOrderedList: {type: Boolean, default: false},
      min: {type: String, default: ''},
      max: {type: String, default: ''},
      dataMin: {type: String, default: '1800-01-01'},
      extraPlugins: {type: Array},
      pushEditorConfig: {type: Object},
      tinyOptions: {type: Object, default: () => ({})},
      // Dono do texto, usado para vincular as imagens anexadas no editor. Opcional: sem ele a imagem
      // funciona e é deduplicada do mesmo jeito, só não fica associada a uma entidade.
      anexoReferencia: {type: String, default: null},
      startsWith: {type: Boolean, default: false},
      dataTestid: String,
      masks: {type: Array, default: () => ([])},
      htmlEditor: {type: Boolean, default: true},
      desativarPermissao: { type: Boolean, default: false },
      rowsTextarea: {type: String, default: "3"},
      autoExpandTextArea: {type: Boolean, default: false},
      help: {type: String, default: null},
    },

    mounted() {
      if ((this.type === 'editor' || this.type === 'classic-editor' || this.type === 'tiny') && this.disabled) {
        let iframe = this.$el?.querySelector("iframe");
        if (iframe) iframe.contentDocument.body.style.cursor = 'not-allowed';
      }

      if (this.autoExpandTextArea && this.idElement().includes('textarea') ) {
        this.ajustarAltura();
      }
    },

  created() {
      //tinymcespellchecker
    if(this.htmlEditor){
      this.tinyConfig.plugins.push('code');
    }
  },

  watch: {
      value: {
        immediate: true,
        handler(val) {
          if ((val === null || val === undefined) && this.default) {
            this.update(this.default);
          } else if (val != this.model) {
            if (this.type == 'checkbox') {
              val = (Array.isArray(val) ? val : [val]).filter(a => a);
              if(this.options.length){
                val = val.filter(o => this.options.find(i => i.id == o));
              }
            }
            this.$set(this, 'model', val);
          }

        }
      },
    },

    computed: {

      searchQueryAutocomplete() {
        return this.searchQuery || this.searchQueryDefault;
      },

      wrapperClass() {
        return `input-${this.type} ${this.error || this.showError ? 'is-invalid' : ''} ${this.valid ? 'is-valid' : ''}`
      },

      inputType() {
        return ['text', 'date', 'time', 'datetime-local', 'month', 'email', 'color', 'password', 'text-compare', 'text-retro'].includes(this.type) ? this.type : false;
      },

      mask() {
        switch (this.type) {
          case 'cep' :
            return '#####-###';
          case 'cpf' :
            return '###.###.###-##';
          case 'cnpj' :
            return 'XX.XXX.XXX/XXXX-##';
          case 'telefone' :
            return ['(##) ####-####', '(##) #####-####'];
          case 'cpfCnpj':
            return ['XXX.XXX.XXX-##', 'XX.XXX.XXX/XXXX-##'];
          case 'mask' :
            return this.masks;
          default:
            return false;
        }
      },

      classes() {
        return `form-control form-control-xs ${this.error || this.showError ? 'is-invalid' : ''} ${this.valid ? 'is-valid' : ''} ${this.disabled ? 'not-allowed' : ''}`.trim()
      },

      attrs() {
        let isCnpjType = this.type === 'cnpj' || this.type === 'cpfCnpj';
        let obj = {
          ...(this.inputProps || {}),
          class: `${this.classes || ''}${isCnpjType ? ' cnpj-uppercase' : ''}`,
          id: this.uuid,
          placeholder: this.placeholder,
          disabled: this.disabled,
          readonly: this.readonly,
        };

        return obj;
      },

      fixedId(){
        return `${this.type}-${this.idindice != '' ? this.idindice + '-' : ''}${this.uuid}`
      },

      server(){
        return window.server.API;
      },

      themeEditor(){
        return this.$root.theme == 'dark' ? 'dark' : 'default'
      },

      skinThemeEditor(){
        return this.$root.theme == 'dark' ? 'oxide-dark' : 'oxide'
      },

      tinyConfigComputed(){
        // O images_upload_handler entra aqui, e não no tinyConfig, porque precisa do componente para
        // chamar a API. Como as demais variantes de editor (ato, inline e leitura) espalham este
        // mesmo objeto, configurar num lugar só cobre todos os editores do sistema.
        return {
          ...this.tinyConfig,
          content_css: this.themeEditor,
          skin: this.skinThemeEditor,
          images_upload_handler: this.uploadImagemEditor,
          ...(this.tinyOptions||{})
        };
      },

      tinyConfigAtoComputed(){

        //https://www.tiny.cloud/solutions/dms-editor/
        let htmlBackground = '#eceef4';
        let background = '#fff';
        if(this.$root.theme == 'dark'){
          htmlBackground = '#1C1E24';
          background = '#222f3e';
        }

        let maxWidth = this.$root.config?.outrosTemplates.editorAtoLargura || '100%';
        let padding = this.$root.config?.outrosTemplates.editorAtoMargem || '2rem';
        let normalEditor = maxWidth == '100%' || maxWidth == '' || maxWidth == '0';

        let content_style = normalEditor ? '' : `
            body {
              background: ${background};
            }

            /* Disable the blue "focus" border for the editable region */
            .editable-section:focus-visible {
              outline: none !important;
            }

            .header,
            .footer {
              font-size: 0.8rem;
              color: #ddd;
            }

            .header {
              display: flex;
              justify-content: space-between;
              padding: 0 0 1rem 0;
            }

            .header .right-text {
              text-align: right;
            }

            .footer {
              padding:2rem 0 0 0;
              text-align: center;
            }

            /* Apply page-like styling */
            @media (min-width: 500px) {
              html {
                background: ${htmlBackground};
                min-height: 100%;
                padding: 0.5rem;
              }

              body {
                background-color: ${background};
                box-shadow: 0 0 4px rgba(0, 0, 0, .5);
                box-sizing: border-box;
                margin: 1rem auto 0;
                width: ${maxWidth};
                min-height: calc(100vh - 1rem);
                padding: ${padding};
              }
            }
          `;

        return {
          ...this.tinyConfigComputed,
          editable_root: true,
          min_height: 200,
          max_height: 600,
          width: "100%",
          content_style: content_style,
        };
      },

      tinyInlineConfigComputed(){
        return {
          ...this.tinyConfigComputed
        };
      },

      readonlyConfigComputed(){
        return {
          ...this.tinyConfigComputed,
          max_height: '999999999px',
          toolbar: false,
          // Visualização não converte nada: o texto não será salvo, então subir a imagem só criaria
          // anexo que ninguém referencia. A conversão fica para quando a tela permitir edição.
          automatic_uploads: false
        };
      },

      titleVSelect(){
        return (this.options || []).find(e => e.id === this.model)?.nome;
      },

    },

    data() {
      let val = this.value ? utils.clone(this.value) : null;

      if (this.type == 'checkbox') {
        val = (Array.isArray(val) ? val : [val]).filter(a => a);
        if(this.options.length){
          val = val.filter(o => this.options.find(i => i.id == o));
        }
        if (val.length != this.value?.length) {
          this.update(val);
        }
      }

      if (this.type == 'radio') {
        if (val === "false") {
          this.update(false);
        }
      }

      // if (this.type == 'datetime-local' && !!val) {
      //   val = val.replace('T', ' ');
      // }

      if (this.type == 'autocomplete' && !!val) {
        val = '';
      }

      var sanitizeWordNode = function(node, aggressive) {
        Array.from(node.querySelectorAll('o\\:p, v\\:shape, v\\:shapetype, v\\:imagedata, w\\:wrap, w\\:anchorlock, xml, style, meta, link')).forEach(function(el) {
          el.remove();
        });

        Array.from(node.querySelectorAll('colgroup')).forEach(function(el) { el.remove(); });

        var walker = document.createTreeWalker(node, NodeFilter.SHOW_COMMENT, null, false);
        var comments = [];
        while (walker.nextNode()) comments.push(walker.currentNode);
        comments.forEach(function(c) { c.remove(); });

        Array.from(node.querySelectorAll('div')).forEach(function(div) {
          if (div.closest('p')) {
            var parent = div.parentNode;
            if (div.previousSibling && div.previousSibling.nodeName !== 'BR') {
              parent.insertBefore(document.createElement('br'), div);
            }
            while (div.firstChild) parent.insertBefore(div.firstChild, div);
            div.remove();
          } else if (div.querySelector('p, h1, h2, h3, h4, h5, h6, table, ul, ol')) {
            var parent = div.parentNode;
            while (div.firstChild) parent.insertBefore(div.firstChild, div);
            div.remove();
          } else if (div.querySelector('br')) {
            var p2 = document.createElement('p');
            while (div.firstChild) p2.appendChild(div.firstChild);
            div.replaceWith(p2);
          } else {
            var parent2 = div.parentNode;
            while (div.firstChild) parent2.insertBefore(div.firstChild, div);
            div.remove();
          }
        });

        Array.from(node.querySelectorAll('font')).forEach(function(font) {
          if (!aggressive) {
            var fontSizes = {'1':'8pt','2':'10pt','3':'12pt','4':'14pt','5':'18pt','6':'24pt','7':'36pt'};
            var styles = [];
            if (font.face) styles.push('font-family: ' + font.face);
            if (font.size && fontSizes[font.size]) styles.push('font-size: ' + fontSizes[font.size]);
            if (styles.length > 0) {
              var span = document.createElement('span');
              span.setAttribute('style', styles.join('; '));
              while (font.firstChild) span.appendChild(font.firstChild);
              font.replaceWith(span);
              return;
            }
          }
          var parent = font.parentNode;
          while (font.firstChild) parent.insertBefore(font.firstChild, font);
          font.remove();
        });

        Array.from(node.querySelectorAll('span')).forEach(function(span) {
          var style = span.getAttribute('style') || '';
          if (aggressive) {
            var parent = span.parentNode;
            while (span.firstChild) parent.insertBefore(span.firstChild, span);
            span.remove();
          } else {
            var hadUnderlineClass = /\bUnderlined\b/i.test(span.className || '');
            span.removeAttribute('class');
            var cleanStyle = style.replace(/[^;]*mso-[^;]+;?/gi, '').trim();
            if (cleanStyle) {
              span.setAttribute('style', cleanStyle);
            } else if (style) {
              span.removeAttribute('style');
            }
            if (hadUnderlineClass && !/text-decoration/i.test(span.getAttribute('style') || '')) {
              var s = span.getAttribute('style') || '';
              span.setAttribute('style', s + (s ? '; ' : '') + 'text-decoration: underline');
            }
            if (!span.getAttribute('style') && span.attributes.length === 0) {
              var parent = span.parentNode;
              while (span.firstChild) parent.insertBefore(span.firstChild, span);
              span.remove();
            }
          }
        });

        if (aggressive) {
          Array.from(node.querySelectorAll('a')).forEach(function(a) {
            var parent = a.parentNode;
            while (a.firstChild) parent.insertBefore(a.firstChild, a);
            a.remove();
          });

          Array.from(node.querySelectorAll('strong, b, em, i')).forEach(function(el) {
            var parent = el.parentNode;
            while (el.firstChild) parent.insertBefore(el.firstChild, el);
            el.remove();
          });
        }

        Array.from(node.querySelectorAll('b, strong')).forEach(function(el) {
          var elStyle = el.getAttribute('style') || '';
          if (/font-weight\s*:\s*normal/i.test(elStyle) || el.querySelector('p, h1, h2, h3, h4, h5, h6, table, ul, ol')) {
            var parent = el.parentNode;
            while (el.firstChild) parent.insertBefore(el.firstChild, el);
            el.remove();
          }
        });

        if (!aggressive) {
          Array.from(node.querySelectorAll('[align]')).forEach(function(el) {
            var align = el.getAttribute('align');
            var existing = el.getAttribute('style') || '';
            if (!/text-align/i.test(existing)) {
              el.setAttribute('style', existing + (existing ? '; ' : '') + 'text-align: ' + align);
            }
            el.removeAttribute('align');
          });
        }

        Array.from(node.querySelectorAll('[style]')).forEach(function(el) {
          var style = el.getAttribute('style');
          if (aggressive) {
            if (/text-decoration[^:]*:\s*underline/i.test(style)) {
              var u = document.createElement('u');
              while (el.firstChild) u.appendChild(el.firstChild);
              el.replaceWith(u);
            } else {
              el.removeAttribute('style');
            }
          } else {
            var hasUnderline = /text-decoration[^:]*:\s*underline/i.test(style);
            var hasBold = /font-weight\s*:\s*(bold|[7-9]00)\b/i.test(style);
            var hasItalic = /font-style\s*:\s*italic/i.test(style);
            var keepProps = /^(font-family|font-size|line-height|text-align|text-indent)$/i;
            var parts = style.split(';');
            var kept = [];
            for (var j = 0; j < parts.length; j++) {
              var part = parts[j].trim();
              if (!part) continue;
              var colonIdx = part.indexOf(':');
              if (colonIdx > 0) {
                var prop = part.substring(0, colonIdx).trim();
                if (keepProps.test(prop)) {
                  kept.push(part);
                }
              }
            }
            var newStyle = kept.join('; ');
            if (newStyle) {
              el.setAttribute('style', newStyle);
            } else {
              el.removeAttribute('style');
            }
            if (hasBold) {
              var strong = document.createElement('strong');
              while (el.firstChild) strong.appendChild(el.firstChild);
              el.appendChild(strong);
            }
            if (hasItalic) {
              var em = document.createElement('em');
              while (el.firstChild) em.appendChild(el.firstChild);
              el.appendChild(em);
            }
            if (hasUnderline) {
              var u = document.createElement('u');
              while (el.firstChild) u.appendChild(el.firstChild);
              el.appendChild(u);
            }
          }
        });

        Array.from(node.querySelectorAll('*')).forEach(function(el) {
          var attrsToRemove = [];
          for (var i = 0; i < el.attributes.length; i++) {
            var name = el.attributes[i].name.toLowerCase();
            if (['class', 'lang', 'dir', 'name', 'title'].includes(name) ||
                name === 'xml:lang' || name === 'xml:space' ||
                name.startsWith('data-') || name.startsWith('xml:') ||
                (name === 'id' && el !== node)) {
              attrsToRemove.push(el.attributes[i].name);
            }
          }
          attrsToRemove.forEach(function(attr) { el.removeAttribute(attr); });
        });

        var keepEmpty = ['BR', 'HR', 'IMG', 'TD', 'TH', 'COL', 'IFRAME'];
        Array.from(node.querySelectorAll('*')).forEach(function(el) {
          if (!keepEmpty.includes(el.tagName) && !el.innerHTML.trim()) {
            el.remove();
          }
        });


        if (!aggressive) {
          Array.from(node.querySelectorAll('span, a, strong, b, em, i, u, font')).forEach(function(el) {
            var s = el.getAttribute('style') || '';
            var ta = s.match(/text-align\s*:\s*([^;]+)/i);
            if (ta) {
              var cleaned = s.replace(/text-align\s*:\s*[^;]+;?\s*/gi, '').trim();
              if (cleaned) el.setAttribute('style', cleaned);
              else el.removeAttribute('style');
              var block = el.closest('p, div, h1, h2, h3, h4, h5, h6, td, th, blockquote');
              if (block && !/text-align/i.test(block.getAttribute('style') || '')) {
                var bs = block.getAttribute('style') || '';
                block.setAttribute('style', bs + (bs ? '; ' : '') + 'text-align: ' + ta[1].trim());
              }
            }
          });
        }
      };

      // Remove o espaço à esquerda do primeiro nó de texto e à direita do último.
      var trimBordasNosDeTexto = function(node) {
        var walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT, null, false);
        var textNode;
        var firstText = null;
        var lastText = null;
        while ((textNode = walker.nextNode())) {
          if (!firstText) firstText = textNode;
          lastText = textNode;
        }
        if (firstText) {
          if (firstText === lastText) {
            firstText.textContent = firstText.textContent.trim();
          } else {
            firstText.textContent = firstText.textContent.replace(/^\s+/, '');
            lastText.textContent = lastText.textContent.replace(/\s+$/, '');
          }
        }
      };

      var sanitizeHtmlString = function(html) {
        var div = document.createElement('div');
        div.innerHTML = html;
        sanitizeWordNode(div, true);
        return div.innerHTML;
      };

      var lastClipboardHtml = '';

      return {
        model: val,
        file: [],
        showError: null,
        uuid: utils.uuid(),
        events: {
          'blur': this.blurEvent,
          'change': this.changeEvent,
          'input': this.inputEvent,
          'keyup.enter': this.enterEvent,
          'enter': this.enterEvent,
          'keypress': this.keypressEvent,
        },

        tinyConfig: {
          browser_spellcheck: true,
          license_key: "go5oky3bl2quqkutip700bunx6iw17b4obiffo48n4bz04p2",
          apiKey: "go5oky3bl2quqkutip700bunx6iw17b4obiffo48n4bz04p2",
          // cache_suffix: '?v=5.8.0',
          // contextmenu: true,
          min_height: 200,
          max_height: 600,
          width: "100%",
          menubar: false,
          language: 'pt_BR',
          content_css: 'dark',
          skin: 'oxide-dark',
          branding: false,
          elementpath: false,
          // verify_html : false,
          remove_trailing_brs: true,
          entity_encoding : "raw",
          encoding: 'xml',
          statusbar: false,
          powerpaste_allow_local_images: true,
          powerpaste_word_import: 'prompt',
          powerpaste_html_import: 'prompt',
          paste_postprocess: function (plugin, args) {
            var aggressive = args.mode === 'clean';
            var editor = plugin;
            var currentNode = editor.selection.getNode();
            var isTableCell = /^(TD|TH)$/i.test(currentNode.tagName);

            if (!aggressive && isTableCell && lastClipboardHtml) {
              var tempDiv = document.createElement('div');
              tempDiv.innerHTML = lastClipboardHtml;
              var pastedCells = Array.from(tempDiv.querySelectorAll('td, th'));

              if (pastedCells.length > 0) {
                var currentRow = currentNode.closest('tr');
                var allCells = Array.from(currentRow.querySelectorAll('td, th'));
                var startIndex = allCells.indexOf(currentNode);

                for (var i = 0; i < pastedCells.length; i++) {
                  var targetIndex = startIndex + i;
                  var targetCell;
                  if (targetIndex < allCells.length) {
                    targetCell = allCells[targetIndex];
                  } else {
                    targetCell = document.createElement('td');
                    currentRow.appendChild(targetCell);
                    allCells.push(targetCell);
                  }
                  targetCell.innerHTML = pastedCells[i].innerHTML;
                  sanitizeWordNode(targetCell, aggressive);
                }
                // O conteúdo já foi distribuído nas células via DOM; esvaziar args.node
                // evita que o TinyMCE insira o HTML bruto do clipboard sobre o resultado.
                args.node.innerHTML = '';
              } else {
                args.node.innerHTML = lastClipboardHtml;
                trimBordasNosDeTexto(args.node);
                sanitizeWordNode(args.node, aggressive);
              }
            } else {
              if (!aggressive && lastClipboardHtml) {
                args.node.innerHTML = lastClipboardHtml;
                trimBordasNosDeTexto(args.node);
              }
              sanitizeWordNode(args.node, aggressive);
            }

            lastClipboardHtml = '';
          },
          setup: function (editor) {
            editor.ui.registry.addButton('limparUnirLinhas', {
              icon: 'ai-prompt',
              tooltip: 'Limpar e unir linhas',
              onAction: function () {
                const dialogApi = editor.windowManager.open({
                  title: 'Limpar e unir linhas',
                  body: {
                    type: 'panel',
                    items: [
                      {type: 'checkbox', name: 'justify', label: 'Justificar texto'},
                      {type: 'checkbox', name: 'cleanSpaces', label: 'Retirar espaços repetidos e aparar início/fim'},
                      {type: 'checkbox', name: 'tightenInlineSpaces', label: 'Retirar espaços em R$123 e dentro de (parênteses)'},
                      {type: 'checkbox', name: 'fixPunctuation', label: 'Corrigir pontuação ( , . : )'},
                      {type: 'checkbox', name: 'mergeLines', label: 'Unir título ao texto com quebra'},
                      {type: 'checkbox', name: 'noNested', label: 'Evitar tags repetidas'}
                    ]
                  },
                  initialData: LimpezaEditorUtils.getPrefs(),
                  buttons: [
                    {type: 'cancel', text: 'Cancelar'},
                    {type: 'submit', name: 'confirmar', text: 'Limpar e unir linhas', primary: true}
                  ],
                  onSubmit: function (api) {
                    const data = api.getData();
                    Object.keys(data).forEach(function (key) {
                      LimpezaEditorUtils.setPref(key, data[key]);
                    });
                    api.close();
                    LimpezaEditorUtils.limparEUnirLinhas(editor);
                  }
                });

                dialogApi.focus('confirmar');
              }
            });

            editor.on('init', function () {
              editor.getBody().addEventListener('paste', function (e) {
                var cd = e.clipboardData;
                if (cd) {
                  lastClipboardHtml = cd.getData('text/html') || '';
                }
              }, true);
            });

            editor.on('ExecCommand', function (e) {
              if (e.command === 'RemoveFormat') {
                var selectedCells = editor.dom.select('td[data-mce-selected],th[data-mce-selected]');
                var selectedHtml, fullHtml, bookmark;

                if (selectedCells.length > 0) {
                  bookmark = editor.selection.getBookmark(2);
                  Array.from(selectedCells).forEach(function(cell) {
                    cell.innerHTML = sanitizeHtmlString(cell.innerHTML);
                  });
                  editor.selection.moveToBookmark(bookmark);
                  editor.nodeChanged();
                  return;
                }

                selectedHtml = editor.selection.getContent({format: 'html'});

                if (selectedHtml && selectedHtml.indexOf('<table') !== -1) {
                  bookmark = editor.selection.getBookmark(2);
                  Array.from(editor.dom.select('td,th')).forEach(function(cell) {
                    cell.innerHTML = sanitizeHtmlString(cell.innerHTML);
                  });
                  editor.selection.moveToBookmark(bookmark);
                  editor.nodeChanged();
                  return;
                }

                fullHtml = editor.getContent();
                if (selectedHtml && selectedHtml !== fullHtml) {
                  editor.selection.setContent(sanitizeHtmlString(selectedHtml));
                } else {
                  editor.setContent(sanitizeHtmlString(fullHtml));
                }

                var current = editor.selection.getNode();
                var body = editor.getBody();
                while (current && current !== body) {
                  var parent = current.parentNode;
                  if (/^(A|STRONG|B|EM|I|U|SPAN|FONT)$/i.test(current.tagName)) {
                    while (current.firstChild) parent.insertBefore(current.firstChild, current);
                    current.remove();
                  }
                  current = parent;
                }

                editor.nodeChanged();
              }
            });
          },
          // spellchecker_active: true,
          // spellchecker_language: 'pt_BR',
          // typography_langs: [ 'pt-BR' ],
          // typography_default_lang: 'pt-BR',
          // plugins:
          //   'advlist searchreplace advcode media table powerpaste advtable visualblocks'
          // , //['powerpaste'],
          plugins: [
            'image', 'lists', 'media', 'searchreplace', 'table', /*'visualblocks',*/ 'fullscreen', 'autoresize',
            'powerpaste', /*'advtable',*/ 'editimage',
          ],
          toolbar:
            'fullscreen styles bold italic underline forecolor backcolor \
            alignleft aligncenter alignright alignjustify \
            bullist numlist outdent indent blockquote table removeformat pastetext image code limparUnirLinhas ', //fontsizeselect lineheight
          table_default_attributes: {
            border: '1'
          },
          table_use_colgroups: false,
          table_default_styles: {
            'border-collapse': 'collapse', 'width': '100%'
          },
          table_advtab: false,
          table_cell_advtab: false,
          table_row_advtab: false,
          table_toolbar: '',

          paste_data_images: true,
          image_title: true,
          automatic_uploads: true,
          file_picker_types: 'image',
          file_picker_callback: function (cb, value, meta) {
            const input = document.createElement('input');
            input.setAttribute('type', 'file');
            input.setAttribute('accept', 'image/*');

            // O arquivo escolhido vai inteiro para o cache do TinyMCE e sobe pelo
            // images_upload_handler, igual ao que é colado ou arrastado. Quem decide se a imagem
            // precisa encolher é o backend, no ImagemTextoBusiness.java — aqui não há canvas nem
            // conversão de formato, porque redimensionar em um caminho de entrada só deixava os
            // outros três passarem direto, e converter tudo para JPEG perdia a transparência dos
            // PNG e degradava imagem que sequer estava acima do limite.
            input.onchange = function () {
              let file = this.files[0];
              let reader = new FileReader();

              reader.onload = function () {
                let blobCache = window.tinymce.activeEditor.editorUpload.blobCache;
                let blobInfo = blobCache.create('blob-' + Date.now(), file, reader.result.split(',')[1], file.name);
                blobCache.add(blobInfo);

                cb(blobInfo.blobUri(), {
                  title: file.name
                });
              };

              reader.readAsDataURL(file);
            };

            input.click();
          },
          //inline_styles: false,
          fix_list_elements : false,
          extended_valid_elements : "strong/b,em/i,u",
          element_format: 'xhtml',
          styles: {
            bold : {inline : 'strong' },
            italic: { inline: 'em' },
            underline: { inline: 'u' },
          },
          formats: {
            bold : {inline : 'strong' },
            italic: { inline: 'em' },
            underline: { inline: 'u' },
          },
          // invalid_elements:'span',

          style_formats_merge: true,
          style_formats: [
            { title: 'Parágrafo Comum', block: 'p' },
            { title: 'Parágrafo Indentado', block: 'p', styles: { textIndent: '40pt' } },
          ],

          // indentation: '20pt',
          // external_plugins: {
          //   powerpaste: "/js/tinymce/powerpaste/plugin.js"
          // },

          // As imagens dos textos são gravadas como anexo e referenciadas por URL relativa à raiz
          // (/api/imagem-texto/{id}), sem esquema nem host, para que o link continue válido se o
          // domínio do cartório mudar. A rota exige sessão — o cookie acompanha o <img src> —, e o
          // renderizador de PDF, que busca sem cookie, nunca chega nela: ImagemTextoBusiness troca a
          // URL pelo conteúdo em data: URI antes de renderizar. O acervo antigo tem a forma pública
          // /api/anexo/public/{id}/download, ainda reconhecida na hora de embutir.
          //
          // convert_urls: false impede o TinyMCE de reescrever qualquer URL ao salvar. Sem isso, a
          // URL absoluta do QR de georreferenciamento (gerada por Dicionario.java com AsgardInit.getApiUrl)
          // era encurtada para URL relativa ao abrir o código-fonte e salvar — o que funcionava na
          // tela (o navegador completa o endereço) mas não no PDF (Flying Saucer sem base URI não
          // resolve URL relativa). As URLs de imagem-texto já são gravadas como relativas pelo
          // images_upload_handler e não são afetadas pela desativação da conversão.
          //
          // relative_urls: false + remove_script_host: true permanecem como fallback, caso convert_urls
          // seja reativado, para preservar o formato raiz-relativo das imagens de anexo.
          convert_urls: false,
          relative_urls: false,
          remove_script_host: true,
          document_base_url: window.server.API,

          content_style: `
            u { text-decoration: underline; }
          `
        }

      }
    },

    methods: {

      /**
       * Sobe para o storage uma imagem que o editor encontrou e devolve a URL que vai para o src.
       *
       * O TinyMCE chama isto em dois momentos, e é o segundo que faz o trabalho pesado: além da
       * imagem que o usuário acabou de colar ou inserir, ele varre o conteúdo carregado atrás de
       * `img[src^="data:"]` e sobe também o base64 que veio do banco. Ou seja, abrir uma tela antiga
       * já limpa o texto — e como o servidor endereça o arquivo pelo hash do conteúdo, reabrir a
       * mesma tela sem salvar não duplica nada no storage.
       */
      async uploadImagemEditor(blobInfo) {
        const retorno = await ImagemTextoBusiness.upload(blobInfo.blob(), blobInfo.filename(), this.anexoReferencia);
        if (!retorno || !retorno.location) {
          throw new Error('Não foi possível enviar a imagem');
        }
        return retorno.location;
      },

      idElement(i) {
        return `${this.fixedId}${(['checkbox', 'radio'].includes(this.type) && i != null) ? '-in-' + i : ''}`;
      },

      blurEvent(e) {
        this.$set(this, 'showError', null);
        if (['date', 'datetime-local'].includes(this.type) && this.model && (this.$moment(this.model).isBefore(this.$moment(this.dataMin)) || !this.$moment(this.model).isValid())) {
          this.$set(this, 'showError', 'Data inválida');
        }
        this.emit('blur', e);
      },

      enterEvent() {
        this.emit('enter');
      },

      keypressEvent(e) {
        this.emit('keypress', e);
      },

      changeEvent(e) {
        if (this.type == 'checkbox' || this.type == 'radio') {
          this.update(this.model, e);
        } else {
          // let value = (e || {}).target ? e.target.value : e;
          this.emit('change', e);
        }
      },

      inputEvent(e) {
        if (this.type == 'checkbox') {
          this.update(this.model, e);
        } else {
          let value = (e || {}).target ? e.target.value : e;
          this.update(value, e);
        }
      },

      update(val, e) {
        this.emit('input', val);
        let changeValue = e != undefined ? e : val;
        this.emit('change', changeValue);
        if (this.type === 'v-select') this.emit('blur', changeValue);
        this.$set(this, 'model', val);
      },

      onkeyup(e){
        this.emit('onkeyup', e);
      },

      emit(event, val) {
        this.$emit(event, val);
      },

      toggleList(value) {
        this.model = Array.isArray(this.model) ? this.model : [];

        if (this.model.includes(value)) {
          this.model = this.model.filter(e => e != value);
        } else {
          this.model.push(value);
        }

        this.update(this.model);
      },

      vSelectForce(item) {
        this.$refs.input.clearSelection();
        if (item) {
          this.$refs.input.updateValue(item);
        } else {
          this.$refs.input.updateValue(item);
        }
        this.$refs.input.closeSearchOptions();
      },

      searchQueryDefault(query = '') {

        let q = query.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");

        if (!q?.length) {
          return null
        }

        return (this.options || [])?.filter((opt) => {
          return opt.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(q)
        });

      },

      filterBy(option, label, search) {
        let q = search.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        let s = (label + "").trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "");
        if(this.startsWith) {
            return s.startsWith(q);
        }
        return s.includes(q);
      },

      async upload(file) {
          if(!this.disabled) {
              let anexos;
              if (this.model) await AnexoBusiness.deleteById(this.model).catch(e => FrontBusiness.showError('', e.message));
              const entidade = EnumAnexoEntidade.getEnumAnexoEntidade(this.entidade);
              return await AnexoBusiness.inserir(file.file, entidade, this.id, undefined, this.checklist).then(async r => {
                  await AnexoBusiness.listar(entidade, this.id).then(l => anexos = l);
                  this.update(anexos[anexos.length - 1].id);
                  await this.emit('blur');
                  // EventBus.$emit('editor');
                  return r;
              }).catch(e => FrontBusiness.showError('', e.message));
          }
      },

      async remover() {
        if (!(await FrontBusiness.confirmarExclusao())) return;
        if(!this.clearable){
          await AnexoBusiness.deleteById(this.model).catch(e => FrontBusiness.showError('', e.message));
          this.update(undefined);
          await this.emit('blur');
        } else {
          await this.emit('remover-file');
        }

        return true;
        // await EventBus.$emit('editor')

      },

      start() {
        this.$refs.upload.active = true;
      },

      withPopper (dropdownList, component, {width}) {
        /**
         * We need to explicitly define the dropdown width since
         * it is usually inherited from the parent with CSS.
         */
        dropdownList.style.width = width;

        /**
         * Here we position the dropdownList relative to the $refs.toggle Element.
         *
         * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
         * the dropdownList overlap by 1 pixel.
         *
         * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
         * wrapper so that we can set some styles for when the dropdown is placed
         * above.
         */
        const popper = createPopper(component.$refs.toggle, dropdownList, {
          placement: 'top',
          modifiers: [
            {
              name: 'offset', options: {
                offset: [0, -1]
              }
            },
            {
              name: 'toggleClass',
              enabled: true,
              phase: 'write',
              fn ({state}) {
                component.$el.classList.toggle('drop-up', state.placement === 'top')
              },
            }]
        });

        /**
         * To prevent memory leaks Popper needs to be destroyed.
         * If you return function, it will be called just before dropdown is removed from DOM.
         */
        return () => popper.destroy();
      },

      /**
       * Ajusta automaticamente a altura do input textarea conforme a quantidade de caracteres digitados
       * A propriedade autoExpandTextArea deve receber o valor true.
       */
      ajustarAltura(event) {
        if (!this.autoExpandTextArea) {
          return;
        }
        const elemento = event ? event.target : document.getElementById(this.idElement());
        elemento.style.height = "auto";
        elemento.style.height = elemento.scrollHeight + "px";
      }

    }
  }
</script>

<style lang=scss>

  input.cnpj-uppercase {
    text-transform: uppercase;
  }

  .tox input.tox-checkbox__input:focus + .tox-checkbox__icons {
    box-shadow: none !important;
  }

  .img {
    height: 230px;
  }

  .upload {
    width: 100%;

    img {
      width: 100%;
      object-fit: contain;
      height: inherit;
      padding: 10px;
      background: white;
    }

    > .btn {
      position: absolute;
      right: 4px;
      top: 8px;
      width: 28px;
      z-index: 1;
    }
  }

  .vs--disabled .vs__dropdown-toggle, .vs--disabled .vs__clear,
  .vs--disabled .vs__search, .vs--disabled .vs__selected,
  .vs--disabled .vs__open-indicator {
    background-color: transparent !important;
  }

  .vs__dropdown-option--disabled {
    opacity: 0.8 !important;
  }

  .vs__dropdown-menu {
    z-index: 9999999999999 !important;
  }

  .input-tags .vs__selected-options .vs__selected, .v-select .vs__selected-options .vs__selected{
    background: #232931;
  }

  .vs--single.vs--open .vs__selected {
    width: 100%;
  }

  input[type="radio"]:disabled {
      position: absolute;
      opacity: 0;
      + .form-check-label {
        color: darken(#e6e6e6, 40%);
        &:before {
          content: '';
          background: #f4f4f4;
          border-radius: 100%;
          border: 1px solid darken(#e6e6e6, 40%);
          display: inline-block;
          width: .8125em;
          height: .8125em;
          position: relative;
          margin-right: .3em;
        }
      }
      &:checked {
        + .form-check-label {
          &:before {
            box-shadow: inset 0 0 0 1.5px #f4f4f4;
            background: darken(#8d8d8d, 35%);
          }
        }
      }
    }

  //.v-select.drop-up.vs--open .vs__dropdown-toggle {
  //  border-radius: 0 0 4px 4px;
  //  border-top-color: transparent;
  //  border-bottom-color: rgba(60, 60, 60, 0.26);
  //}

  //[data-popper-placement='top'] {
  //  border-radius: 4px 4px 0 0;
  //  border-top-style: solid;
  //  border-bottom-style: none;
  //  box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15)
  //}

  select optgroup{
    background: #000;
    color: #fff;
    font-style: normal;
    font-weight: normal;
  }

</style>
